import { jsx, jsxs } from "react/jsx-runtime";
import {
  Avatar,
  Button,
  CounterBadge,
  __css,
  Menu,
  MenuDivider,
  MenuGroup,
  MenuGroupHeader,
  MenuItem,
  MenuItemRadio,
  MenuList,
  MenuPopover,
  MenuTrigger,
  PresenceBadge,
  Tooltip,
  tokens
} from "@fluentui/react-components";
import {
  Alert20Regular,
  Building20Regular,
  ChevronDown16Regular,
  Comment20Regular,
  DarkTheme20Regular,
  LocalLanguage20Regular,
  PeopleCommunity20Regular,
  Person20Regular,
  QuestionCircle20Regular,
  Search20Regular,
  ShieldLock20Regular,
  SignOut20Regular
} from "@fluentui/react-icons";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { comboLabel, SHELL_SHORTCUTS } from "../shortcuts/registry.js";
import { useShortcut } from "../shortcuts/react.js";
import { useShell } from "./app-shell.js";
import { box, boxColor } from "./styles.js";
import { initialsOf } from "../components/internal/initials.js";
import { brandTokens } from "../theme/themes.js";
import { layout } from "../theme/tokens.js";
const BRAND_NAME = "BatiFlow";
const LOGO_ARCH_PATH = "M9 24V15A7 7 0 0 1 23 15V24H19V15.5A3 3 0 0 0 13 15.5V24Z";
const LOGO_FLOW_PATH = "M6 27H19C23.5 27 25.5 25 26.5 21";
const useStyles = __css({"header":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":0,"Belr9w4":0,"rmohyg":"f19gb1f4","st59p4":"f1hxgz52","Bnnss6s":"fi64zpg","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f1thqed2","De3pzq":"f16xq7d1","Bw6cc19":0,"Bj04r6y":0,"Bdehfym":"f11echem"},"logoSlot":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","Bnnss6s":"fi64zpg","B1hrpyx":"f1xswkeg","Bnt446c":"f19v1juz","B0czu1p":"f19g71x2","Bhzhn95":"fsrlaf6"},"logo":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":0,"Belr9w4":0,"rmohyg":"faqewft","Bhrd7zp":"fl43uef","Be2twd7":"fg38ndl","ublp8o":"f4c95hg","Huce71":"fz5stix","B5fkk8g":"fwcdv7d"},"word":{"qhf8xq":"f10pi13n","Bsft5z2":"f13zj6fq","E3zdtr":"f1mdlcz9","mpp2jd":"f1ej75lk","atrxzc":"f1auu1wt","Byqounk":"f1r1mvck","qwzx0r":"f12ddnw6","d9w3h3":0,"B3778ie":0,"B4j8arr":0,"Bl18szs":0,"Blrzh8d":"f3b9emi","Bjyk6c5":"fn66vg3"},"logoMark":{"mc9l5x":"ftgm304","Bnnss6s":"fi64zpg"},"logoTile":{"Bkfmm31":"fgiysr9"},"logoArch":{"Bkfmm31":"f4b0fqn"},"logoFlow":{"ojy3ng":"f1byc8nh"},"wordBati":{"sj55zd":"fluovtf"},"wordFlow":{"sj55zd":"fbs4bkf"},"searchSlot":{"Bh6795r":"fqerorx","mc9l5x":"f22iagw","Brf1p80":"fbhxue7","Bgto7am":"fw6al7a"},"search":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":0,"Belr9w4":0,"rmohyg":"faqewft","Bns2gvi":"f1c209jx","D305fb":"f105rpuy","st59p4":"fykvlqy","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f12n3xlw","B4m11q7":"f32hy0g","rm1204":"fwyddsq","ijz38e":"f1ftuoky","tzxy30":"fgmlvap","Bwezv66":"fwl1lcr","Ctt3hk":"f1crbv9w","gggo0z":"fi15kbk","B834pou":"f1taw3pw","F1poyb":"foi3q75","Behc1zw":"f10zy6vx","uk9mye":"f1p2dij1","mbw9mh":"f1a566p","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"ft85np5","De3pzq":"fxugw4r","sj55zd":"f11d4kpn","Be2twd7":"fkhj508","Bahqtrf":"f1mo0ibp","Bceei9c":"f113hnb5","fsow6f":"fpgzoln","Br2s7ns":"feor3og","B8u4isl":"fm6yb8a","Bw3w3vb":"f1hk8eyo","Bel3mw0":"f93rcai","Beohmeb":"f1u5sdlw","B486eqv":"f1u8i3ug","vu0emg":"fvi4nxw"},"searchText":{"Bh6795r":"fqerorx","B68tc82":0,"Bmxbyg5":0,"Bpg54ce":"f1a3p1vp","ygn44y":"f1cmbuwj","Huce71":"fz5stix"},"kbd":{"Bahqtrf":"f1fedwem","Be2twd7":"f13mqy1h","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f1rktw8j","B4m11q7":"f32hy0g","rm1204":"fwyddsq","ijz38e":"f1ftuoky","tzxy30":"fgmlvap","Bwezv66":"fwl1lcr","Ctt3hk":"f1crbv9w","gggo0z":"fi15kbk","B834pou":"f1taw3pw","F1poyb":"foi3q75","Behc1zw":"f10zy6vx","uk9mye":"f1p2dij1","mbw9mh":"f1a566p","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"fq9zq91"},"actions":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":0,"Belr9w4":0,"rmohyg":"fkln5zr"},"bell":{"qhf8xq":"f10pi13n"},"bellBadge":{"qhf8xq":"f1euv43f","Bwk1v6v":"f7b6qr0","Bvbap8t":"fpqfqxv","Bkecrkj":"f1aehjj5"},"orgButton":{"D305fb":"f19bvf2r"},"orgName":{"B68tc82":0,"Bmxbyg5":0,"Bpg54ce":"f1a3p1vp","ygn44y":"f1cmbuwj","Huce71":"fz5stix"}});
function BatiFlowLogo() {
  const styles = useStyles();
  return (
    // Product name: brand, not translated. The lockup is never mirrored: the mark stays before
    // the word in Arabic too (docs/brand/README.md §4).
    /* @__PURE__ */ jsxs("span", { className: styles.logo, dir: "ltr", role: "img", "aria-label": BRAND_NAME, children: [
      /* @__PURE__ */ jsxs(
        "svg",
        {
          className: styles.logoMark,
          viewBox: "0 0 32 32",
          width: "28",
          height: "28",
          "aria-hidden": "true",
          focusable: "false",
          children: [
            /* @__PURE__ */ jsx("rect", { className: styles.logoTile, width: "32", height: "32", rx: "7" }),
            /* @__PURE__ */ jsx("path", { className: styles.logoArch, d: LOGO_ARCH_PATH }),
            /* @__PURE__ */ jsx(
              "path",
              {
                className: styles.logoFlow,
                d: LOGO_FLOW_PATH,
                fill: "none",
                strokeWidth: "2.5",
                strokeLinecap: "round"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsxs("span", { "aria-hidden": "true", className: styles.word, children: [
        /* @__PURE__ */ jsx("span", { className: styles.wordBati, children: "Bati" }),
        /* @__PURE__ */ jsx("span", { className: styles.wordFlow, children: "Flow" })
      ] })
    ] })
  );
}
function Header({
  onOpenSearch,
  orgSwitcher,
  help,
  notifications,
  account,
  logo
}) {
  const styles = useStyles();
  const { t } = useTranslation("ui");
  const { tier } = useShell();
  useShortcut(SHELL_SHORTCUTS.search, onOpenSearch);
  const compact = tier === "phone";
  return /* @__PURE__ */ jsxs("header", { className: styles.header, children: [
    /* @__PURE__ */ jsx("div", { className: styles.logoSlot, children: logo ?? /* @__PURE__ */ jsx(BatiFlowLogo, {}) }),
    /* @__PURE__ */ jsx("div", { className: styles.searchSlot, children: compact ? /* @__PURE__ */ jsx(Tooltip, { content: t("shell.search.open"), relationship: "inaccessible", children: /* @__PURE__ */ jsx(
      Button,
      {
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(Search20Regular, {}),
        "aria-label": t("shell.search.open"),
        onClick: onOpenSearch
      }
    ) }) : /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: styles.search,
        onClick: onOpenSearch,
        "aria-keyshortcuts": "Control+K /",
        children: [
          /* @__PURE__ */ jsx(Search20Regular, { "aria-hidden": true }),
          /* @__PURE__ */ jsx("span", { className: styles.searchText, children: t("shell.search.placeholder") }),
          /* @__PURE__ */ jsx("kbd", { className: styles.kbd, dir: "ltr", children: comboLabel(SHELL_SHORTCUTS.search.combos[0]) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
      orgSwitcher,
      help,
      notifications,
      account
    ] })
  ] });
}
const HelpButton = forwardRef(
  function HelpButton2(props, ref) {
    const { t } = useTranslation("ui");
    const label = t("shell.help");
    return /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "inaccessible", children: /* @__PURE__ */ jsx(
      Button,
      {
        ...props,
        ref,
        appearance: "subtle",
        icon: /* @__PURE__ */ jsx(QuestionCircle20Regular, {}),
        "aria-label": label
      }
    ) });
  }
);
const NotificationsButton = forwardRef(
  function NotificationsButton2({ count = 0, ...rest }, ref) {
    const styles = useStyles();
    const { t } = useTranslation("ui");
    const label = t("shell.notificationsCount", { count });
    return /* @__PURE__ */ jsxs("span", { className: styles.bell, children: [
      /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "inaccessible", children: /* @__PURE__ */ jsx(
        Button,
        {
          ...rest,
          ref,
          appearance: "subtle",
          icon: /* @__PURE__ */ jsx(Alert20Regular, {}),
          "aria-label": label
        }
      ) }),
      count > 0 && /* @__PURE__ */ jsx(
        CounterBadge,
        {
          className: styles.bellBadge,
          count,
          size: "small",
          overflowCount: 99,
          "aria-hidden": true
        }
      )
    ] });
  }
);
function OrgSwitcher({
  organizations,
  activeId,
  onSwitch,
  externalSpacesCount = 0,
  onOpenExternalSpaces
}) {
  const styles = useStyles();
  const { t } = useTranslation("ui");
  const { tier } = useShell();
  const active = organizations.find((o) => o.id === activeId);
  const onCheckedValueChange = (_e, data) => {
    const id = data.checkedItems[0];
    if (id && id !== activeId) onSwitch(id);
  };
  const iconOnly = tier === "phone" || tier === "tablet";
  const label = active ? t("shell.orgSwitcherCurrent", { name: active.name }) : t("shell.orgSwitcher");
  return /* @__PURE__ */ jsxs(
    Menu,
    {
      checkedValues: { org: activeId ? [activeId] : [] },
      onCheckedValueChange,
      children: [
        /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(Tooltip, { content: label, relationship: "inaccessible", children: /* @__PURE__ */ jsxs(
          Button,
          {
            appearance: "subtle",
            className: styles.orgButton,
            icon: /* @__PURE__ */ jsx(Building20Regular, {}),
            iconPosition: "before",
            "aria-label": label,
            children: [
              !iconOnly && /* @__PURE__ */ jsx("span", { className: styles.orgName, dir: "auto", children: active?.name }),
              !iconOnly && /* @__PURE__ */ jsx(ChevronDown16Regular, { "aria-hidden": true })
            ]
          }
        ) }) }),
        /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
          /* @__PURE__ */ jsxs(MenuGroup, { children: [
            /* @__PURE__ */ jsx(MenuGroupHeader, { children: t("shell.orgSwitcher") }),
            organizations.map((o) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "org", value: o.id, children: o.name }, o.id))
          ] }),
          /* @__PURE__ */ jsx(MenuDivider, {}),
          /* @__PURE__ */ jsx(
            MenuItem,
            {
              icon: /* @__PURE__ */ jsx(PeopleCommunity20Regular, {}),
              disabled: !onOpenExternalSpaces,
              onClick: onOpenExternalSpaces,
              children: externalSpacesCount > 0 ? t("shell.externalSpacesCount", { count: externalSpacesCount }) : t("shell.externalSpaces")
            }
          )
        ] }) })
      ]
    }
  );
}
const PRESENCE_BADGE = {
  available: "available",
  busy: "busy",
  in_meeting: "do-not-disturb",
  on_site: "out-of-office",
  away: "away",
  offline: "offline"
};
const THEME_LABEL_KEY = {
  system: "shell.themes.system",
  light: "shell.themes.light",
  dark: "shell.themes.dark",
  hc: "shell.themes.highContrast"
};
const SELECTABLE_PRESENCE = ["available", "busy", "on_site", "away"];
function AccountMenu({
  user,
  language,
  onLanguageChange,
  theme,
  onThemeChange,
  onOpenProfile,
  onOpenSecurity,
  onPresenceChange,
  statusMessage,
  onEditStatusMessage,
  onSignOut
}) {
  const { t } = useTranslation("ui");
  const presence = user.presence ?? "available";
  return /* @__PURE__ */ jsxs(Menu, { children: [
    /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(
      Tooltip,
      {
        content: t("shell.account.menu", { name: user.displayName }),
        relationship: "inaccessible",
        children: /* @__PURE__ */ jsx(
          Button,
          {
            appearance: "subtle",
            shape: "circular",
            "aria-label": t("shell.account.menu", { name: user.displayName }),
            children: /* @__PURE__ */ jsx(
              Avatar,
              {
                name: user.displayName,
                initials: initialsOf(user.displayName),
                ...user.avatarUrl ? { image: { src: user.avatarUrl } } : {},
                size: 28,
                badge: {
                  status: PRESENCE_BADGE[presence],
                  "aria-label": t(`shell.presence.${presence}`)
                }
              }
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsxs(MenuList, { children: [
      /* @__PURE__ */ jsxs(MenuGroup, { children: [
        /* @__PURE__ */ jsx(MenuGroupHeader, { children: user.displayName }),
        onPresenceChange ? /* @__PURE__ */ jsxs(
          Menu,
          {
            checkedValues: { presence: [presence] },
            onCheckedValueChange: (_e, d) => {
              const next = SELECTABLE_PRESENCE.find((value) => value === d.checkedItems[0]);
              if (next) onPresenceChange(next);
            },
            children: [
              /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(PresenceBadge, { status: PRESENCE_BADGE[presence], "aria-hidden": true }), children: t("shell.account.statusValue", { status: t(`shell.presence.${presence}`) }) }) }),
              /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: SELECTABLE_PRESENCE.map((value) => /* @__PURE__ */ jsx(
                MenuItemRadio,
                {
                  name: "presence",
                  value,
                  icon: /* @__PURE__ */ jsx(PresenceBadge, { status: PRESENCE_BADGE[value], "aria-hidden": true }),
                  children: t(`shell.presence.${value}`)
                },
                value
              )) }) })
            ]
          }
        ) : /* @__PURE__ */ jsx(
          MenuItem,
          {
            icon: /* @__PURE__ */ jsx(PresenceBadge, { status: PRESENCE_BADGE[presence], "aria-hidden": true }),
            disabled: true,
            children: t("shell.account.statusValue", { status: t(`shell.presence.${presence}`) })
          }
        ),
        onEditStatusMessage ? /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Comment20Regular, {}), onClick: onEditStatusMessage, children: statusMessage ? t("shell.account.statusMessageEdit") : t("shell.account.statusMessageSet") }) : null,
        statusMessage ? /* @__PURE__ */ jsx(MenuItem, { disabled: true, children: /* @__PURE__ */ jsx("bdi", { children: t("shell.account.statusMessageValue", { message: statusMessage }) }) }) : null
      ] }),
      /* @__PURE__ */ jsx(MenuDivider, {}),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(Person20Regular, {}), disabled: !onOpenProfile, onClick: onOpenProfile, children: t("shell.account.profile") }),
      /* @__PURE__ */ jsx(
        MenuItem,
        {
          icon: /* @__PURE__ */ jsx(ShieldLock20Regular, {}),
          disabled: !onOpenSecurity,
          onClick: onOpenSecurity,
          children: t("shell.account.security")
        }
      ),
      /* @__PURE__ */ jsxs(
        Menu,
        {
          checkedValues: { language: [language] },
          onCheckedValueChange: (_e, d) => {
            const next = d.checkedItems[0];
            if (next === "fr" || next === "ar" || next === "en") onLanguageChange(next);
          },
          children: [
            /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(LocalLanguage20Regular, {}), children: t("shell.account.language") }) }),
            /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: ["fr", "ar", "en"].map((lng) => /* @__PURE__ */ jsx(
              MenuItemRadio,
              {
                name: "language",
                value: lng,
                lang: lng,
                dir: lng === "ar" ? "rtl" : "ltr",
                children: t(`shell.languages.${lng}`)
              },
              lng
            )) }) })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        Menu,
        {
          checkedValues: { theme: [theme] },
          onCheckedValueChange: (_e, d) => {
            const next = d.checkedItems[0];
            if (next === "system" || next === "light" || next === "dark" || next === "hc")
              onThemeChange(next);
          },
          children: [
            /* @__PURE__ */ jsx(MenuTrigger, { disableButtonEnhancement: true, children: /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(DarkTheme20Regular, {}), children: t("shell.account.theme") }) }),
            /* @__PURE__ */ jsx(MenuPopover, { children: /* @__PURE__ */ jsx(MenuList, { children: ["system", "light", "dark", "hc"].map((choice) => /* @__PURE__ */ jsx(MenuItemRadio, { name: "theme", value: choice, children: t(THEME_LABEL_KEY[choice]) }, choice)) }) })
          ]
        }
      ),
      /* @__PURE__ */ jsx(MenuDivider, {}),
      /* @__PURE__ */ jsx(MenuItem, { icon: /* @__PURE__ */ jsx(SignOut20Regular, {}), onClick: onSignOut, children: t("shell.account.signOut") })
    ] }) })
  ] });
}
export {
  AccountMenu,
  BRAND_NAME,
  BatiFlowLogo,
  Header,
  HelpButton,
  LOGO_ARCH_PATH,
  LOGO_FLOW_PATH,
  NotificationsButton,
  OrgSwitcher,
  SELECTABLE_PRESENCE
};
//# sourceMappingURL=header.js.map

import "/opt/batiflow/app/packages/ui/dist/shell/header.griffel.css";